import LoginScreen from 'src/screens/Login';
import LegacyFlowRedirect from 'src/screens/FlowWorkspace/LegacyFlowRedirect';
import WorkspaceEntry from 'src/screens/FlowWorkspace/WorkspaceEntry';
import NotSignalScreen from 'src/screens/NotSignal';
import WelcomeScreen from 'src/screens/WelcomeScreen';
import ScaningChannelsScreen from 'src/screens/ScaningChannels';
import RegisterScreen from 'src/screens/Register';
// import EnterPasswordScene from 'src/screens/EnterPassword'
import RestorePasswordScene from 'src/screens/RestorePassword';
import CreatePasswordScene from 'src/screens/CreatePassword';
import BeginWorkScreen from 'src/screens/BeginWork';
import KeywordsScreen from 'src/screens/Keywords';
import CollectionScreen from 'src/screens/Collections';
import ChangePasswordScreen from 'src/screens/ChangePassword';
import FeedScreen from 'src/screens/Feed';
import AIManagerDetailsScreen from 'src/screens/AIManagerDetails/index';
import AIManagerSetupScreen from 'src/screens/AIManagerSetup';
import KnowledgeBaseScreen from 'src/screens/KnowledgeBase';
import IntegrationsScreen from 'src/screens/Integrations';
import SalesFunnelScreen from 'src/screens/SalesFunnel';
import ChatsAndChannelsScreen from 'src/screens/ChatsAndChannels';
import BeginWorkKeywords from 'src/screens/BeginWork/Keywords';
import { ROUTES_URL } from 'src/constants/routes';
import BeginWorkCollections from 'src/screens/BeginWork/Collections';
import BeginWorkChatsAndChannels from 'src/screens/BeginWork/ChatsAndChannels';
import BeginWorkFormat from 'src/screens/BeginWork/FormatWrapper';
import ChangeEmailScreen from 'src/screens/ChangeEmail';
import NotFound404 from 'src/screens/NotFound404';
import DescribeYourBusiness from 'src/screens/BeginWork/DescribeYourBusiness';
import CreateProject from 'src/screens/BeginWork/CreateProject';
import NotificationsScreen from 'src/screens/Notifications';
import PartnershipScreen from 'src/screens/Partnership';
import ProfileScreen from 'src/screens/Profile';
import ProjectsScreen from 'src/screens/Projects/index';
import ProjectPaymentScreen from 'src/screens/ProjectPayment';
import NewProjectScreen from 'src/screens/NewProject';
import AboutProjectScreen from 'src/screens/AboutProject';
import FlowLaunchEntry from 'src/screens/FlowWorkspace/FlowLaunchEntry';
import LeadStreamDetailsScreen from 'src/screens/LeadStreamDetails/index';
import LeadsmaniaBillingRedirect from 'src/screens/LeadsmaniaBilling';
// removed ProjectOnboardingScreen

import type { TRoutesKeys, TRoutesPath } from 'src/constants/routes';

type RouteInfo = {
    path: TRoutesPath;
    component: any;
    isPublic: boolean;
    exact: boolean;
};

export type RouteName = TRoutesKeys;

type RoutesType = Record<TRoutesKeys, RouteInfo>;

const ROUTES: RoutesType = {
    FLOWS: { path: ROUTES_URL.FLOWS, component: LegacyFlowRedirect, isPublic: false, exact: true },
    WORKSPACE: { path: ROUTES_URL.WORKSPACE, component: WorkspaceEntry, isPublic: false, exact: true },
    LOGIN: {
        path: ROUTES_URL.LOGIN,
        component: LoginScreen,
        isPublic: true,
        exact: true,
    },
    REGISTER: {
        path: ROUTES_URL.REGISTER,
        component: RegisterScreen,
        isPublic: true,
        exact: true,
    },
    // ENTER_PASSWORD: {
    //     path: '/password',
    //     component: EnterPasswordScene,
    //     isPublic: true,
    //     exact: true,
    // },
    RESTORE_PASSWORD: {
        path: ROUTES_URL.RESTORE_PASSWORD,
        component: RestorePasswordScene,
        isPublic: true,
        exact: true,
    },
    CREATE_PASSWORD: {
        path: ROUTES_URL.CREATE_PASSWORD,
        component: CreatePasswordScene,
        isPublic: true,
        exact: true,
    },
    CHANGE_PASSWORD: {
        path: ROUTES_URL.CHANGE_PASSWORD,
        component: ChangePasswordScreen,
        isPublic: false,
        exact: true,
    },
    CHANGE_EMAIL: {
        path: ROUTES_URL.CHANGE_EMAIL,
        component: ChangeEmailScreen,
        isPublic: false,
        exact: true,
    },
    BEGIN_WORK_SUBSCRIPTIONS: {
        path: ROUTES_URL.BEGIN_WORK_SUBSCRIPTIONS,
        component: LeadsmaniaBillingRedirect,
        isPublic: false,
        exact: true,
    },
    BEGIN_WORK_DESCRIPTION: {
        path: ROUTES_URL.BEGIN_WORK_DESCRIPTION,
        component: DescribeYourBusiness,
        isPublic: false,
        exact: true,
    },
    BEGIN_WORK_CREATE_PROJECT: {
        path: ROUTES_URL.BEGIN_WORK_CREATE_PROJECT,
        component: CreateProject,
        isPublic: false,
        exact: true,
    },
    BEGIN_WORK_COLLECTIONS: {
        path: ROUTES_URL.BEGIN_WORK_COLLECTIONS,
        component: BeginWorkCollections,
        isPublic: false,
        exact: true,
    },
    BEGIN_WORK_CHATS_AND_CHANNELS: {
        path: ROUTES_URL.BEGIN_WORK_CHATS_AND_CHANNELS,
        component: BeginWorkChatsAndChannels,
        isPublic: false,
        exact: true,
    },
    BEGIN_WORK_KEYWORDS: {
        path: ROUTES_URL.BEGIN_WORK_KEYWORDS,
        component: BeginWorkKeywords,
        isPublic: false,
        exact: true,
    },
    BEGIN_WORK_FORMAT: {
        path: ROUTES_URL.BEGIN_WORK_FORMAT,
        component: BeginWorkFormat,
        isPublic: false,
        exact: true,
    },
    BEGIN_WORK: {
        path: ROUTES_URL.BEGIN_WORK,
        component: BeginWorkScreen,
        isPublic: false,
        exact: true,
    },
    BEGIN_WORK_PAYMENT: {
        path: ROUTES_URL.BEGIN_WORK_PAYMENT,
        component: LeadsmaniaBillingRedirect,
        isPublic: false,
        exact: true,
    },
    NO_SIGNAL: {
        path: ROUTES_URL.NO_SIGNAL,
        component: NotSignalScreen,
        isPublic: true,
        exact: true,
    },
    WELCOME_SCREEN: {
        path: ROUTES_URL.WELCOME_SCREEN,
        component: WelcomeScreen,
        isPublic: false,
        exact: true,
    },
    SCANING_CHANNELS: {
        path: ROUTES_URL.SCANING_CHANNELS,
        component: ScaningChannelsScreen,
        isPublic: false,
        exact: true,
    },
    SUBSCRIPTIONS: {
        path: ROUTES_URL.SUBSCRIPTIONS,
        component: LeadsmaniaBillingRedirect,
        isPublic: false,
        exact: true,
    },
    PAYMENT: {
        path: ROUTES_URL.PAYMENT,
        component: LeadsmaniaBillingRedirect,
        isPublic: false,
        exact: true,
    },
    CHATS_AND_CHANNELS: {
        path: ROUTES_URL.CHATS_AND_CHANNELS,
        component: ChatsAndChannelsScreen,
        isPublic: false,
        exact: true,
    },
    KEYWORDS: {
        path: ROUTES_URL.KEYWORDS,
        component: KeywordsScreen,
        isPublic: false,
        exact: true,
    },
    COLLECTIONS: {
        path: ROUTES_URL.COLLECTIONS,
        component: CollectionScreen,
        isPublic: false,
        exact: true,
    },
    FEED: {
        path: ROUTES_URL.FEED,
        component: FeedScreen,
        isPublic: false,
        exact: true,
    },
    AI_MANAGER_NEW: {
        path: ROUTES_URL.AI_MANAGER_NEW,
        component: AIManagerSetupScreen,
        isPublic: false,
        exact: true,
    },
    AI_MANAGER_SETUP: {
        path: ROUTES_URL.AI_MANAGER_SETUP,
        component: AIManagerSetupScreen,
        isPublic: false,
        exact: true,
    },
    AI_MANAGER_DETAIL: {
        path: ROUTES_URL.AI_MANAGER_DETAIL,
        component: AIManagerDetailsScreen,
        isPublic: false,
        exact: true,
    },
    KNOWLEDGE_BASE: {
        path: ROUTES_URL.KNOWLEDGE_BASE,
        component: KnowledgeBaseScreen,
        isPublic: false,
        exact: true,
    },
    INTEGRATIONS: {
        path: ROUTES_URL.INTEGRATIONS,
        component: IntegrationsScreen,
        isPublic: false,
        exact: true,
    },
    SALES_FUNNEL: {
        path: ROUTES_URL.SALES_FUNNEL,
        component: SalesFunnelScreen,
        isPublic: false,
        exact: true,
    },
    MY_TARIFF: {
        path: ROUTES_URL.MY_TARIFF,
        component: LeadsmaniaBillingRedirect,
        isPublic: false,
        exact: true,
    },
    NOT_FOUND: {
        path: ROUTES_URL.NOT_FOUND,
        component: NotFound404,
        isPublic: true,
        exact: false,
    },
    NOTIFICATIONS: {
        path: ROUTES_URL.NOTIFICATIONS,
        component: NotificationsScreen,
        isPublic: false,
        exact: true,
    },
    PARTNERSHIP: {
        path: ROUTES_URL.PARTNERSHIP,
        component: PartnershipScreen,
        isPublic: false,
        exact: true,
    },
    PROFILE: {
        path: ROUTES_URL.PROFILE,
        component: ProfileScreen,
        isPublic: false,
        exact: true,
    },
    PROJECTS: {
        path: ROUTES_URL.PROJECTS,
        component: ProjectsScreen,
        isPublic: false,
        exact: true,
    },
    PROJECT_PAYMENT: {
        path: ROUTES_URL.PROJECT_PAYMENT,
        component: ProjectPaymentScreen,
        isPublic: false,
        exact: true,
    },
    NEW_PROJECT: {
        path: ROUTES_URL.NEW_PROJECT,
        component: NewProjectScreen,
        isPublic: false,
        exact: true,
    },
    ABOUT_PROJECT: {
        path: ROUTES_URL.ABOUT_PROJECT,
        component: AboutProjectScreen,
        isPublic: false,
        exact: true,
    },
    LEADSTREAM: {
        path: ROUTES_URL.LEADSTREAM,
        component: FlowLaunchEntry,
        isPublic: false,
        exact: true,
    },
    LEADSTREAM_DETAIL: {
        path: ROUTES_URL.LEADSTREAM_DETAIL,
        component: LeadStreamDetailsScreen,
        isPublic: false,
        exact: true,
    },
    // PROJECT_ONBOARDING removed
};

export default ROUTES;
